import Phaser from 'phaser';

const W = 14;
const H = 20;

/** Generate unique sprites for each special character */
export function generateSpecialCharacterTextures(scene: Phaser.Scene): void {
  generateJames(scene);
  generateKevin(scene);
  generateAndrew(scene);
  generateAndrewShirtless(scene);
  generateStu(scene);
  generatePedro(scene);
  generateMike(scene);
  generateClaude(scene);
  generatePoggy(scene);
  generateEarl(scene);
  generateRpgProjectile(scene);
}

/** James - slick guy in a white shirt, sunglasses */
function generateJames(scene: Phaser.Scene): void {
  const key = 'special-james';
  if (scene.textures.exists(key)) return;
  const canvas = scene.textures.createCanvas(key, W, H)!;
  const ctx = canvas.context;

  // Hair - slicked back dark
  ctx.fillStyle = '#1a1a1a';
  ctx.beginPath();
  ctx.arc(W / 2, 4, 4, Math.PI, 0);
  ctx.fill();

  // Head
  ctx.fillStyle = '#f0c090';
  ctx.beginPath();
  ctx.arc(W / 2, 5, 3.5, 0, Math.PI * 2);
  ctx.fill();

  // Sunglasses
  ctx.fillStyle = '#000000';
  ctx.fillRect(W / 2 - 3, 4, 2.5, 1.5);
  ctx.fillRect(W / 2 + 0.5, 4, 2.5, 1.5);

  // White polo shirt
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(W / 2 - 4, 8, 8, 6);

  // Khaki pants
  ctx.fillStyle = '#c8b070';
  ctx.fillRect(W / 2 - 3, 14, 3, 5);
  ctx.fillRect(W / 2, 14, 3, 5);

  canvas.refresh();
}

/** Kevin - flannel shirt hipster, beard */
function generateKevin(scene: Phaser.Scene): void {
  const key = 'special-kevin';
  if (scene.textures.exists(key)) return;
  const canvas = scene.textures.createCanvas(key, W, H)!;
  const ctx = canvas.context;

  // Beanie
  ctx.fillStyle = '#cc4400';
  ctx.fillRect(W / 2 - 4, 0, 8, 4);

  // Head
  ctx.fillStyle = '#f0c090';
  ctx.beginPath();
  ctx.arc(W / 2, 5, 3.5, 0, Math.PI * 2);
  ctx.fill();

  // Beard
  ctx.fillStyle = '#8B4513';
  ctx.beginPath();
  ctx.arc(W / 2, 7, 2.5, 0, Math.PI);
  ctx.fill();

  // Flannel shirt (red plaid)
  ctx.fillStyle = '#cc2222';
  ctx.fillRect(W / 2 - 4, 8, 8, 6);
  ctx.fillStyle = '#882222';
  ctx.fillRect(W / 2 - 4, 8, 2, 2);
  ctx.fillRect(W / 2, 8, 2, 2);
  ctx.fillRect(W / 2 - 4, 12, 2, 2);
  ctx.fillRect(W / 2, 12, 2, 2);

  // Jeans
  ctx.fillStyle = '#334466';
  ctx.fillRect(W / 2 - 3, 14, 3, 5);
  ctx.fillRect(W / 2, 14, 3, 5);

  canvas.refresh();
}

/** Andrew - tank top, big arms, wild hair */
function generateAndrew(scene: Phaser.Scene): void {
  const key = 'special-andrew';
  if (scene.textures.exists(key)) return;
  const canvas = scene.textures.createCanvas(key, W, H)!;
  const ctx = canvas.context;

  // Wild spiky hair
  ctx.fillStyle = '#ffdd00';
  ctx.beginPath();
  ctx.moveTo(W / 2 - 4, 5);
  ctx.lineTo(W / 2 - 2, 0);
  ctx.lineTo(W / 2, 3);
  ctx.lineTo(W / 2 + 2, 0);
  ctx.lineTo(W / 2 + 4, 5);
  ctx.closePath();
  ctx.fill();

  // Head
  ctx.fillStyle = '#f0c090';
  ctx.beginPath();
  ctx.arc(W / 2, 5, 3.5, 0, Math.PI * 2);
  ctx.fill();

  // Big grin
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(W / 2, 6, 1.5, 0, Math.PI);
  ctx.fill();

  // Neon green tank top
  ctx.fillStyle = '#00ff00';
  ctx.fillRect(W / 2 - 3, 8, 6, 6);

  // Arms out (wider body for arms)
  ctx.fillStyle = '#f0c090';
  ctx.fillRect(W / 2 - 5, 9, 2, 4);
  ctx.fillRect(W / 2 + 3, 9, 2, 4);

  // Shorts
  ctx.fillStyle = '#222222';
  ctx.fillRect(W / 2 - 3, 14, 6, 3);

  // Legs
  ctx.fillStyle = '#f0c090';
  ctx.fillRect(W / 2 - 3, 17, 2, 2);
  ctx.fillRect(W / 2 + 1, 17, 2, 2);

  canvas.refresh();
}

/** Andrew shirtless - same but skin-colored torso, shirt waving overhead */
function generateAndrewShirtless(scene: Phaser.Scene): void {
  const key = 'special-andrew-shirtless';
  if (scene.textures.exists(key)) return;
  const canvas = scene.textures.createCanvas(key, W, H)!;
  const ctx = canvas.context;

  // Wild spiky hair
  ctx.fillStyle = '#ffdd00';
  ctx.beginPath();
  ctx.moveTo(W / 2 - 4, 5);
  ctx.lineTo(W / 2 - 2, 0);
  ctx.lineTo(W / 2, 3);
  ctx.lineTo(W / 2 + 2, 0);
  ctx.lineTo(W / 2 + 4, 5);
  ctx.closePath();
  ctx.fill();

  // Head
  ctx.fillStyle = '#f0c090';
  ctx.beginPath();
  ctx.arc(W / 2, 5, 3.5, 0, Math.PI * 2);
  ctx.fill();

  // Big grin
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(W / 2, 6, 1.5, 0, Math.PI);
  ctx.fill();

  // Bare chest (skin colored torso)
  ctx.fillStyle = '#f0c090';
  ctx.fillRect(W / 2 - 3, 8, 6, 6);

  // Arms out (wider body for arms)
  ctx.fillRect(W / 2 - 5, 9, 2, 4);
  ctx.fillRect(W / 2 + 3, 9, 2, 4);

  // Shirt waving above head (held in raised hand)
  ctx.fillStyle = '#00ff00';
  ctx.beginPath();
  ctx.moveTo(W / 2 + 3, 0);
  ctx.lineTo(W / 2 + 6, 2);
  ctx.lineTo(W / 2 + 4, 4);
  ctx.lineTo(W / 2 + 1, 2);
  ctx.closePath();
  ctx.fill();

  // Shorts
  ctx.fillStyle = '#222222';
  ctx.fillRect(W / 2 - 3, 14, 6, 3);

  // Legs
  ctx.fillStyle = '#f0c090';
  ctx.fillRect(W / 2 - 3, 17, 2, 2);
  ctx.fillRect(W / 2 + 1, 17, 2, 2);

  canvas.refresh();
}

/** Stu - bald, glasses, polo. Head drawn separately for color cycling */
function generateStu(scene: Phaser.Scene): void {
  const key = 'special-stu';
  if (scene.textures.exists(key)) return;
  const canvas = scene.textures.createCanvas(key, W, H)!;
  const ctx = canvas.context;

  // Bald head (no hair, shiny highlight)
  ctx.fillStyle = '#f0c090';
  ctx.beginPath();
  ctx.arc(W / 2, 5, 4, 0, Math.PI * 2);
  ctx.fill();

  // Shine on bald head
  ctx.fillStyle = 'rgba(255,255,255,0.4)';
  ctx.beginPath();
  ctx.arc(W / 2 - 1, 3, 1.5, 0, Math.PI * 2);
  ctx.fill();

  // Glasses
  ctx.strokeStyle = '#333333';
  ctx.lineWidth = 0.8;
  ctx.beginPath();
  ctx.arc(W / 2 - 2, 5, 1.5, 0, Math.PI * 2);
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(W / 2 + 2, 5, 1.5, 0, Math.PI * 2);
  ctx.stroke();

  // Blue polo
  ctx.fillStyle = '#3366cc';
  ctx.fillRect(W / 2 - 4, 9, 8, 6);

  // Khakis
  ctx.fillStyle = '#c8b070';
  ctx.fillRect(W / 2 - 3, 15, 3, 4);
  ctx.fillRect(W / 2, 15, 3, 4);

  canvas.refresh();
}

/** Pedro - bandana, muscle shirt, carrying a tube on his back */
function generatePedro(scene: Phaser.Scene): void {
  const key = 'special-pedro';
  if (scene.textures.exists(key)) return;
  const canvas = scene.textures.createCanvas(key, W, H)!;
  const ctx = canvas.context;

  // Bandana
  ctx.fillStyle = '#ff0000';
  ctx.fillRect(W / 2 - 4, 1, 8, 3);

  // Head
  ctx.fillStyle = '#d4a060';
  ctx.beginPath();
  ctx.arc(W / 2, 5, 3.5, 0, Math.PI * 2);
  ctx.fill();

  // Mustache
  ctx.fillStyle = '#1a1a1a';
  ctx.fillRect(W / 2 - 2, 6, 4, 1.5);

  // Camo shirt
  ctx.fillStyle = '#4a6b3a';
  ctx.fillRect(W / 2 - 4, 8, 8, 6);
  ctx.fillStyle = '#3a5a2a';
  ctx.fillRect(W / 2 - 2, 9, 3, 2);
  ctx.fillRect(W / 2 + 1, 11, 2, 2);

  // RPG tube on back (diagonal line)
  ctx.strokeStyle = '#555555';
  ctx.lineWidth = 2.5;
  ctx.beginPath();
  ctx.moveTo(W / 2 + 4, 2);
  ctx.lineTo(W / 2 - 2, 14);
  ctx.stroke();

  // Pants
  ctx.fillStyle = '#4a6b3a';
  ctx.fillRect(W / 2 - 3, 14, 3, 5);
  ctx.fillRect(W / 2, 14, 3, 5);

  canvas.refresh();
}

/** Mike - plain regular dude, slightly transparent looking */
function generateMike(scene: Phaser.Scene): void {
  const key = 'special-mike';
  if (scene.textures.exists(key)) return;
  const canvas = scene.textures.createCanvas(key, W, H)!;
  const ctx = canvas.context;

  // Normal hair
  ctx.fillStyle = '#553300';
  ctx.beginPath();
  ctx.arc(W / 2, 3, 4, Math.PI, 0);
  ctx.fill();

  // Head
  ctx.fillStyle = '#f0c090';
  ctx.beginPath();
  ctx.arc(W / 2, 5, 3.5, 0, Math.PI * 2);
  ctx.fill();

  // Friendly smile
  ctx.strokeStyle = '#aa6633';
  ctx.lineWidth = 0.8;
  ctx.beginPath();
  ctx.arc(W / 2, 6, 1.2, 0, Math.PI);
  ctx.stroke();

  // Grey hoodie
  ctx.fillStyle = '#888888';
  ctx.fillRect(W / 2 - 4, 8, 8, 7);
  // Hood bump
  ctx.fillStyle = '#777777';
  ctx.beginPath();
  ctx.arc(W / 2, 8, 3, Math.PI, 0);
  ctx.fill();

  // Jeans
  ctx.fillStyle = '#334466';
  ctx.fillRect(W / 2 - 3, 15, 3, 4);
  ctx.fillRect(W / 2, 15, 3, 4);

  canvas.refresh();
}

/** Claude - sparkle-shaped AI character in warm terra cotta */
function generateClaude(scene: Phaser.Scene): void {
  const key = 'special-claude';
  if (scene.textures.exists(key)) return;
  const canvas = scene.textures.createCanvas(key, W, H)!;
  const ctx = canvas.context;

  const cx = W / 2;
  const centerY = 7;

  // Claude sparkle: 4 main points (N/S/E/W) with shorter diagonal points
  // This matches the actual Claude logo shape — a 4-pointed star with subtle mid-points
  ctx.fillStyle = '#D97757';
  ctx.beginPath();
  const points = 8;
  for (let i = 0; i < points; i++) {
    const angle = (i / points) * Math.PI * 2 - Math.PI / 2;
    // Cardinal directions (0,2,4,6) get long spokes, diagonals get short
    const isCardinal = i % 2 === 0;
    const r = isCardinal ? 6 : 2.5;
    const px = cx + Math.cos(angle) * r;
    const py = centerY + Math.sin(angle) * r;
    if (i === 0) ctx.moveTo(px, py);
    else ctx.lineTo(px, py);
  }
  ctx.closePath();
  ctx.fill();

  // Lighter inner star
  ctx.fillStyle = '#E8946E';
  ctx.beginPath();
  for (let i = 0; i < points; i++) {
    const angle = (i / points) * Math.PI * 2 - Math.PI / 2;
    const isCardinal = i % 2 === 0;
    const r = isCardinal ? 3.5 : 1.5;
    const px = cx + Math.cos(angle) * r;
    const py = centerY + Math.sin(angle) * r;
    if (i === 0) ctx.moveTo(px, py);
    else ctx.lineTo(px, py);
  }
  ctx.closePath();
  ctx.fill();

  // Bright center dot
  ctx.fillStyle = '#F5C4A1';
  ctx.beginPath();
  ctx.arc(cx, centerY, 1.2, 0, Math.PI * 2);
  ctx.fill();

  // Tiny legs
  ctx.fillStyle = '#D97757';
  ctx.fillRect(cx - 2, 13, 1.5, 4);
  ctx.fillRect(cx + 0.5, 13, 1.5, 4);

  // Little feet
  ctx.fillStyle = '#C06545';
  ctx.fillRect(cx - 2.5, 16, 2.5, 1.5);
  ctx.fillRect(cx, 16, 2.5, 1.5);

  canvas.refresh();
}

/** Poggy - nervous guy in a hoodie, wide scared eyes, hunched */
function generatePoggy(scene: Phaser.Scene): void {
  const key = 'special-poggy';
  if (scene.textures.exists(key)) return;
  const canvas = scene.textures.createCanvas(key, W, H)!;
  const ctx = canvas.context;

  // Hoodie pulled up over head
  ctx.fillStyle = '#2d5a27';
  ctx.beginPath();
  ctx.arc(W / 2, 5, 5, Math.PI, 0);
  ctx.fill();
  ctx.fillRect(W / 2 - 5, 5, 10, 3);

  // Head (peeking out of hoodie)
  ctx.fillStyle = '#f0c090';
  ctx.beginPath();
  ctx.arc(W / 2, 6, 3, 0, Math.PI * 2);
  ctx.fill();

  // Wide scared eyes
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(W / 2 - 1.5, 5.5, 1.5, 0, Math.PI * 2);
  ctx.fill();
  ctx.beginPath();
  ctx.arc(W / 2 + 1.5, 5.5, 1.5, 0, Math.PI * 2);
  ctx.fill();
  // Tiny pupils looking sideways
  ctx.fillStyle = '#000000';
  ctx.beginPath();
  ctx.arc(W / 2 - 1, 5.5, 0.7, 0, Math.PI * 2);
  ctx.fill();
  ctx.beginPath();
  ctx.arc(W / 2 + 2, 5.5, 0.7, 0, Math.PI * 2);
  ctx.fill();

  // Worried mouth
  ctx.strokeStyle = '#aa6633';
  ctx.lineWidth = 0.8;
  ctx.beginPath();
  ctx.arc(W / 2, 7.5, 1, Math.PI, 0); // upside-down arc = frown
  ctx.stroke();

  // Green hoodie body (hunched, arms crossed)
  ctx.fillStyle = '#2d5a27';
  ctx.fillRect(W / 2 - 4, 8, 8, 7);
  // Crossed arms
  ctx.fillStyle = '#245020';
  ctx.fillRect(W / 2 - 3, 10, 6, 3);

  // Jeans
  ctx.fillStyle = '#334466';
  ctx.fillRect(W / 2 - 3, 15, 3, 4);
  ctx.fillRect(W / 2, 15, 3, 4);

  canvas.refresh();
}

/** Earl - guy on a bicycle with helmet and jersey */
function generateEarl(scene: Phaser.Scene): void {
  const key = 'special-earl';
  if (scene.textures.exists(key)) return;
  const EW = 16; // wider to fit the bike
  const EH = 20;
  const canvas = scene.textures.createCanvas(key, EW, EH)!;
  const ctx = canvas.context;
  const cx = EW / 2;

  // Helmet
  ctx.fillStyle = '#cc0000';
  ctx.beginPath();
  ctx.arc(cx, 3, 3.5, Math.PI, 0);
  ctx.fill();
  // Helmet brim
  ctx.fillRect(cx - 4, 3, 8, 1);

  // Head
  ctx.fillStyle = '#f0c090';
  ctx.beginPath();
  ctx.arc(cx, 5, 3, 0, Math.PI * 2);
  ctx.fill();

  // Sunglasses
  ctx.fillStyle = '#333333';
  ctx.fillRect(cx - 2.5, 4, 2, 1.2);
  ctx.fillRect(cx + 0.5, 4, 2, 1.2);

  // Jersey (cycling kit - blue with white stripe)
  ctx.fillStyle = '#2266cc';
  ctx.fillRect(cx - 3, 8, 6, 5);
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(cx - 3, 10, 6, 1);

  // Arms gripping handlebars
  ctx.fillStyle = '#f0c090';
  ctx.fillRect(cx - 5, 9, 2, 2);
  ctx.fillRect(cx + 3, 9, 2, 2);

  // Legs (bent, pedaling position)
  ctx.fillStyle = '#1a1a1a';
  ctx.fillRect(cx - 2, 13, 2, 3);
  ctx.fillRect(cx + 1, 13, 2, 3);

  // Bike frame (diamond shape)
  ctx.strokeStyle = '#888888';
  ctx.lineWidth = 1.2;
  ctx.beginPath();
  // Top tube
  ctx.moveTo(cx - 4, 13);
  ctx.lineTo(cx + 4, 13);
  // Seat tube
  ctx.moveTo(cx - 1, 11);
  ctx.lineTo(cx - 4, 17);
  // Down tube
  ctx.moveTo(cx - 1, 11);
  ctx.lineTo(cx + 4, 17);
  // Seat stay
  ctx.moveTo(cx - 4, 17);
  ctx.lineTo(cx - 4, 13);
  // Chain stay
  ctx.moveTo(cx - 4, 17);
  ctx.lineTo(cx + 4, 17);
  // Fork
  ctx.moveTo(cx + 4, 13);
  ctx.lineTo(cx + 4, 17);
  ctx.stroke();

  // Wheels
  ctx.strokeStyle = '#555555';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.arc(cx - 4, 17, 2.5, 0, Math.PI * 2);
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(cx + 4, 17, 2.5, 0, Math.PI * 2);
  ctx.stroke();

  // Handlebar
  ctx.strokeStyle = '#666666';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(cx + 3, 11);
  ctx.lineTo(cx + 5, 10);
  ctx.stroke();

  canvas.refresh();
}

/** RPG projectile - a small rocket */
function generateRpgProjectile(scene: Phaser.Scene): void {
  const key = 'rpg-projectile';
  if (scene.textures.exists(key)) return;
  const canvas = scene.textures.createCanvas(key, 8, 16)!;
  const ctx = canvas.context;

  // Rocket body
  ctx.fillStyle = '#666666';
  ctx.fillRect(2, 4, 4, 8);

  // Nose cone
  ctx.fillStyle = '#ff4400';
  ctx.beginPath();
  ctx.moveTo(4, 0);
  ctx.lineTo(6, 4);
  ctx.lineTo(2, 4);
  ctx.closePath();
  ctx.fill();

  // Fins
  ctx.fillStyle = '#888888';
  ctx.beginPath();
  ctx.moveTo(1, 12);
  ctx.lineTo(2, 8);
  ctx.lineTo(2, 12);
  ctx.closePath();
  ctx.fill();
  ctx.beginPath();
  ctx.moveTo(7, 12);
  ctx.lineTo(6, 8);
  ctx.lineTo(6, 12);
  ctx.closePath();
  ctx.fill();

  // Exhaust
  ctx.fillStyle = '#ff8800';
  ctx.beginPath();
  ctx.arc(4, 14, 2, 0, Math.PI * 2);
  ctx.fill();

  canvas.refresh();
}
